import { CarrierVisitDirection, OrderResponseDto, UnloadingMethod } from '@planning/app/api'

export type OogFormData = {
  isOog?: boolean
  overLengthRear?: number | null
  overLengthFront?: number | null
  overWidthLeft?: number | null
  overWidthRight?: number | null
  overHeight?: number | null
  unloadingMethod?: UnloadingMethod | null
  direction?: CarrierVisitDirection
}

export const createOogFormDataFromOrderResponse = (order?: OrderResponseDto): OogFormData => {
  return {
    isOog: order?.isOOG ?? false,
    overLengthRear: order?.overLengthRear,
    overLengthFront: order?.overLengthFront,
    overWidthLeft: order?.overWidthLeft,
    overWidthRight: order?.overWidthRight,
    overHeight: order?.overHeight,
    unloadingMethod: order?.unloadingMethod,
    direction: order?.direction,
  }
}
